import React, { useState } from "react";
import { User, Package, Truck } from "lucide-react";
import Profile from "./Profile";
import Mybooking from "./Mybooking";
import "./MyBookings.css";

const MyBookings = () => {
  const [activeTab, setActiveTab] = useState("profile");

  const tabs = [
    { key: "profile", icon: User, label: "Profile" },
    { key: "mybookings", icon: Package, label: "My Bookings" },
    { key: "track", icon: Truck, label: "Track Order" },
  ];

  const renderContent = () => {
    switch (activeTab) {
      case "profile":
        return <Profile />;
      case "mybookings":
        return <Mybooking />;
      case "track":
        return (
          <div className="ym-card ym-card-pad" style={{ textAlign: "center", padding: "60px 24px" }}>
            <Truck size={48} color="var(--ym-muted)" style={{ marginBottom: 20 }} />
            <h3 className="ym-service-title" style={{ fontSize: 18, marginBottom: 8 }}>Track Order</h3>
            <p className="ym-text" style={{ color: "var(--ym-muted)", margin: 0 }}>Tracking functionality coming soon...</p>
          </div>
        );
      default:
        return <Profile />;
    }
  };

  return (
    <section className="ym-section" style={{ paddingTop: 40 }}>
      <div className="ym-container">
        <div style={{ textAlign: "center", marginBottom: 32 }}>
          <span className="ym-eyebrow" style={{ marginInline: "auto" }}>
            <User size={14} />
            My Account
          </span>
          <h2 className="ym-title-small">Manage your profile and bookings.</h2>
        </div>

        {/* Mobile horizontal tabs */}
        <div className="myb-mobile-tabs">
          {tabs.map((tab) => (
            <button
              key={tab.key}
              onClick={() => setActiveTab(tab.key)}
              className={`myb-tab ${activeTab === tab.key ? "myb-tab-active" : ""}`}
            >
              <tab.icon size={16} />
              {tab.label}
            </button>
          ))}
        </div>

        {/* Desktop sidebar + content */}
        <div className="myb-body">
          <div className="myb-sidebar">
            <div className="myb-sidebar-header">Dashboard</div>
            {tabs.map((tab) => (
              <button
                key={tab.key}
                onClick={() => setActiveTab(tab.key)}
                className={`myb-nav-item ${activeTab === tab.key ? "myb-nav-item-active" : ""}`}
              >
                <tab.icon size={18} />
                {tab.label}
              </button>
            ))}
          </div>
          <div className="myb-content">
            {renderContent()}
          </div>
        </div>
      </div>
    </section>
  );
};

export default MyBookings;
